import { render, staticRenderFns } from "./amsInfo.vue?vue&type=template&id=216ed5e2&scoped=true&"
import script from "./amsInfo.vue?vue&type=script&lang=js&"
export * from "./amsInfo.vue?vue&type=script&lang=js&"
import style0 from "./amsInfo.vue?vue&type=style&index=0&id=216ed5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ed5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216ed5e2')) {
      api.createRecord('216ed5e2', component.options)
    } else {
      api.reload('216ed5e2', component.options)
    }
    module.hot.accept("./amsInfo.vue?vue&type=template&id=216ed5e2&scoped=true&", function () {
      api.rerender('216ed5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/amsInfo.vue"
export default component.exports